import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { NestApiProvider } from '../nest-api';
import { ResponseData } from '../nest-responses';

@Injectable()
export class ARAPAdjustmentApi {

  private service: string = '';
  private model: string = 'erp/arap';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public getRequestDetail(payload: { requestNo: string}): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getRequestDetail';
    const params: any = payload || {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public getRequest(payload: { requestNo: string}): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getRequest';
    const params: any = payload || {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/erp/arapadjustment.api.ts